import { useGlobal } from '../context/GlobalContext';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../App';

interface LoginResponse {
  email: string;
  name: string;
  userKey: string;
  projects: Array<{
    projectKey: string;
    projectName: string;
  }>;
}

export function useLogin() {
  const { setEmail, setUserKey, setUserName, setProjects, setSelectedProjectKey } = useGlobal();
  const navigate = useNavigate();

  const login = async (email: string, password: string) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Login failed');
    }
    
    const data: LoginResponse = await response.json();
    
    setEmail(data.email);
    setUserKey(data.userKey);
    setUserName(data.name);
    setProjects(data.projects);
    setSelectedProjectKey(data.projects[0]?.projectKey || '');
    
    navigate('/overview');
  };

  return { login };
}
